module.exports = __webpack_public_path__ + "img/tuto_in.8866cc42.svg";